import ContentLoader from "@edusogno/composites/content-loader";
import { cn } from "@edusogno/lib/utils";
import { useEffect, useState } from "react";

interface Props {
  images: string[];
  pdfDetails: { maxPages: number; currentPage: number };
  setPdfDetails: React.Dispatch<
    React.SetStateAction<{ maxPages: number; currentPage: number }>
  >;
}

export default function MaterialImagesPaginator({ images, setPdfDetails, pdfDetails }: Props) {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const handler = () => {
      const pdfContainer = document.getElementById("pdf-reader-container");
      if (pdfContainer !== null) {
        const dimensions = pdfContainer.getBoundingClientRect();
        pdfContainer.style.setProperty("--pdf-h", `${dimensions.height}px`);
        pdfContainer.style.setProperty("--pdf-w", `${dimensions.width}px`);
      }
    };

    handler();

    window.addEventListener("resize", handler);

    return () => {
      window.removeEventListener("resize", handler);
    };
  }, []);

  useEffect(() => {
    if (images.length === 0) return
    setLoading(false);

    setPdfDetails((prev) => ({ ...prev, maxPages: images.length }));
  }, [images, setPdfDetails]);

  return (
    <div
      id="pdf-reader-container"
      className="flex flex-col w-full space-y-4 h-fit"
    >
      <div
        className={cn(
          "flex flex-col gap-2 p-4 items-center bg-white h-[80%] rounded-[10px] w-full mx-auto flex-1 bg-white/40",
          {
            "justify-content items-center": loading,
            "w-full h-full": loading,
          },
        )}
      >
        <div
          className={cn(
            `overflow-y-auto custom-scroll h-full w-full justify-center items-start flex`,
            { hidden: loading },
          )}
        >

          <div className={cn("overflow-x-hidden overflow-y-auto w-full h-full", {
            hidden: loading,
          })}>
            {images?.map((image, idx) => (
              <img
                hidden={idx !== pdfDetails?.currentPage - 1}
                src={image}
                alt={`Page ${idx + 1}`}
                key={idx}
                loading="lazy"
                className={"!w-full"}
              />
            ))}
          </div>


        </div>

        {images.length === 0 && (
          <div className="flex items-center justify-center w-full h-full">
            <ContentLoader className={"m-auto self-center"} />
          </div>
        )}
      </div>
    </div>
  );
}
